import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RenderIf from '../../render-if/components/render-if';

class PageHeader extends Component {
  render() {
    const { t } = this.context;
    const { title, customClass, translationObject, actionBtn, displayBtn, btnCallback } = this.props;

    return (
      <div className={`row m-b-20 ${customClass ? customClass : ''}`}>
        <h2 className={`${actionBtn && displayBtn && btnCallback ? 'col-md-9' : 'col-md-12'}`}>{t(title, translationObject || {})}</h2>
        <RenderIf if={actionBtn && displayBtn && btnCallback}>
          <div className="col-md-3 m-t-20 m-b-10">
            <div className="transparent-btn pull-right" onClick={btnCallback}>
              {t('PAYMENT_METHODS.ADD_METHOD_BTN')}
            </div>
          </div>
        </RenderIf>
      </div>
    );
  }
}

PageHeader.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/app/shared/page-header/components/page-header.js